import React from 'react';

export const UtahInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">City of Salt Lake City</p>
        <p className="eds-l-mar-bot-1">
            <strong>Emergency Loan Program</strong> |&nbsp;
            <a
                href="https://www.slc.gov/ed/covid19/"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            For business owners, 0% interest loans of up to $20,000 as part of
            the city’s emergency loan program.
        </p>
    </div>
);
